import { render, staticRenderFns } from "./DetalleCentro.vue?vue&type=template&id=4a50e27c&"
import script from "./DetalleCentro.vue?vue&type=script&lang=js&"
export * from "./DetalleCentro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports